import { render } from "./realtime-monitor-ems.vue?vue&type=template&id=0f4454e1"
import script from "./realtime-monitor-ems.vue?vue&type=script&lang=js"
export * from "./realtime-monitor-ems.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__